/*
* Pipeline Theme Custom JS
*/

if (window.theme && window.theme.custom && window.theme.custom.page_type == 'product') {
  (function() {
    const ratio = document.querySelector('.product__headline .rating__wrapper__title');
    const jdgmcontent = document.querySelector('.jdgm-header');
    if (ratio && jdgmcontent) {
      ratio.addEventListener('click', () => {
        jdgmcontent.scrollIntoView({ behavior: 'smooth', block: 'start' })
      })
    }
  })();
}


/* Fix for PageFly missing prices on live pages */
document.addEventListener('DOMContentLoaded', function() {
    function renderPageFlyPrices() {
        if (!window.__pageflyProducts) return;
        
        var priceDivs = document.querySelectorAll('div[data-pf-type="ProductPrice2"]');
        priceDivs.forEach(function(el) {
            if (el.innerHTML.trim() !== '') return;
            
            var parent = el.parentElement;
            if (!parent) return;
            var titleEl = parent.querySelector('[data-product-id]');
            if (!titleEl) titleEl = el.previousElementSibling;
            
            if (titleEl && titleEl.hasAttribute('data-product-id')) {
                var productId = titleEl.getAttribute('data-product-id');
                var pData = window.__pageflyProducts[productId];
                
                if (pData && pData.selected_or_first_available_variant) {
                    var variant = pData.selected_or_first_available_variant;
                    var price = variant.price;
                    var compare_at_price = variant.compare_at_price;
                    
                    var moneyFormat = (window.__pagefly_setting__ && window.__pagefly_setting__.moneyFormat) 
                        ? window.__pagefly_setting__.moneyFormat 
                        : "<span class=money>${{amount}}</span>";
                        
                    var formatPrice = function(cents) {
                        var amountStr = (cents / 100).toFixed(2);
                        // Some Shopify formats use {{amount_no_decimals}}
                        var str = moneyFormat.replace(/\{\{amount\}\}/g, amountStr)
                                             .replace(/\{\{amount_with_comma_separator\}\}/g, amountStr);
                        return str;
                    };
                    
                    var html = '';
                    if (compare_at_price > price) {
                        html += '<s style="font-size:0.85em; opacity:0.6; margin-right:6px;">' + formatPrice(compare_at_price) + '</s>';
                    }
                    html += '<span style="font-weight:600;">' + formatPrice(price) + '</span>';
                    
                    el.innerHTML = html;
                }
            }
        });
    }
    
    renderPageFlyPrices();
    setTimeout(renderPageFlyPrices, 1000);
    setTimeout(renderPageFlyPrices, 2500);
});

/* Account Button handler & Klaviyo Customer Hub Interception Fix */
(function() {
    function getAccountUrl() {
        var root = (window.theme && window.theme.routes && window.theme.routes.root_url) ? window.theme.routes.root_url : '/';
        if (root.charAt(root.length - 1) !== '/') {
            root += '/';
        }
        return root + 'account';
    }

    function protectAccountLinks() {
        var accountLinks = document.querySelectorAll('a[href*="account"], [data-mobile-account-link], .header__desktop__button a, .drawer__account, a[href="#k-hub"]');
        accountLinks.forEach(function(link) {
            var href = link.getAttribute('href') || '';
            if (href.indexOf('account') !== -1 || link.matches('[data-mobile-account-link], .drawer__account') || link.closest('.header__desktop__button')) {
                link.setAttribute('data-k-hub-ignore', 'true');
                if (href === '#k-hub') {
                    link.setAttribute('href', getAccountUrl());
                }
            }
        });
    }

    document.addEventListener('DOMContentLoaded', protectAccountLinks);
    window.addEventListener('load', protectAccountLinks);

    function handleAccountClick(e) {
        var mobileBtn = e.target.closest('[data-mobile-account-link]');
        var desktopBtn = e.target.closest('.header__desktop__button a, a[href="#k-hub"], a.drawer__account');

        if (!mobileBtn && !desktopBtn) return;

        // If Shopify New Customer Accounts modal API is available, invoke it
        if (window.Shopify && window.Shopify.CustomerAccounts && typeof window.Shopify.CustomerAccounts.openLoginModal === 'function') {
            e.preventDefault();
            e.stopPropagation();
            window.Shopify.CustomerAccounts.openLoginModal();
            return;
        }

        var targetLink = mobileBtn || desktopBtn;
        var href = targetLink.getAttribute('href') || '';

        // If hijacked to #k-hub, prevent anchor jump and navigate directly to /account
        if (href === '#k-hub' || href === '#' || href === '') {
            e.preventDefault();
            e.stopPropagation();
            window.location.href = getAccountUrl();
            return;
        }
    }

    document.addEventListener('click', handleAccountClick, true);
})();


/* Dynamic SKU update when variant changes */
document.addEventListener('change', function(e) {
  if (e.target.matches('input[name^="options["], select[name^="options["]')) {
    setTimeout(function() {
      var skuJsonEl = document.querySelector('[data-product-variants-sku-json]');
      var skuValEl = document.querySelector('[data-sku-value]');
      if (!skuJsonEl || !skuValEl) return;
      try {
        var skuMap = JSON.parse(skuJsonEl.textContent);
        var form = e.target.closest('form') || document.querySelector('form[action*="/cart/add"]');
        var idInput = form ? form.querySelector('input[name="id"]') : document.querySelector('input[name="id"]');
        if (idInput && idInput.value && skuMap[idInput.value]) {
          skuValEl.textContent = skuMap[idInput.value];
        }
      } catch (err) {}
    }, 50);
  }
});
